import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css'
import { IframeProvider } from './context/IframeContext';
import Dashboard from './views/Dashboard';
import { MetricCategoriesProvider } from './context/MetricCategoriesContext';
import { MetadataProvider } from './context/MetadataContext';
import { OrgIdProvider } from './context/OrgIdContext';
import ReportPage from './views/ReportPage';
import { LayersProvider } from './context/LayersContext';

function App() {

  return (
    <Router>
      <IframeProvider>
        <OrgIdProvider>
          <LayersProvider>
            <MetricCategoriesProvider>
              <MetadataProvider>
                <Routes>
                  <Route path="/:uuid" element={<Dashboard />} />
                  <Route path="/report" element={<ReportPage />} />
                </Routes>
              </MetadataProvider>
            </MetricCategoriesProvider>
          </LayersProvider>
        </OrgIdProvider>
      </IframeProvider>
    </Router>
  )
}

export default App
